import React, { useState, useRef, useEffect } from 'react';
import Fuse from 'fuse.js';
import { MaginifyIcon, CloseIcon } from '../../../../../atoms/material-icons';
import PropTypes from 'prop-types';
import './search-indices.m.css';

const SearchIndices = ({ onStockSearch, onCloseSearch }) => {
  const [stocksData, setStocksData] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [searchResult, setSearchResult] = useState([]);
  const [showSearchList, setShowSearchList] = useState(false);
  const searchRef = useRef(null);

  useEffect(() => {
    const getStocksListData = async () => {
      try {
        const stockDetailsResponse = await fetch(
          '/feapi/markets/external-indices/indices/indian-indices',
        );
        const stockDetailsData = await stockDetailsResponse.json();
        setStocksData(stockDetailsData?.data);
        setSearchQuery('SENSEX');
      } catch (error) {
        console.log('Error in searching stocks', error);
      }
    };
    getStocksListData();
  }, []);

  const fuse = new Fuse(stocksData, {
    keys: ['sname'],
    shouldSort: true,
    threshold: 0.3,
    location: 0,
    distance: 50,
    maxPatternLength: 32,
    minMatchCharLength: 2,
  });

  const onSearch = (event) => {
    const value = event.target.value;
    setSearchQuery(value);
    if (value) {
      const results =
        fuse &&
        fuse?._docs.filter(
          (item) =>
            item?.sname?.toLowerCase().includes(value.toLowerCase()) ||
            item?.name?.toLowerCase().includes(value.toLowerCase()),
        );
      setSearchResult(results);
      setShowSearchList(true);
    }
  };
  const suggestionSelected = (value) => {
    setSearchQuery(value?.sname);
    onStockSearch(value?.sname, value?.id);
    setSearchResult([]);
    setShowSearchList(false);
  };

  const clearSearch = () => {
    setSearchQuery('SENSEX');
    onStockSearch('SENSEX', 1);
    setSearchResult([]);
    setShowSearchList(false);
    onCloseSearch(true);
  };
  // Hide the search list when clicking outside the component
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setShowSearchList(false);
      }
    };
    const handleScroll = () => {
      setShowSearchList(false);
    };

    document.addEventListener('mousedown', handleClickOutside);
    window.addEventListener('scroll', handleScroll);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      window.removeEventListener('scroll', handleScroll);
    };
  }, [searchRef]);

  return (
    <div styleName="search-stocks" ref={searchRef}>
      <input
        id="inputStock"
        placeholder="Search Stocks"
        list="stocks"
        value={searchQuery}
        onChange={(event) => onSearch(event)}
        onFocus={() => {
          setSearchQuery('');
          setSearchResult(stocksData);
          setShowSearchList(true);
        }}
      />

      <ul styleName={showSearchList ? 'show' : 'hide'}>
        {searchResult?.length > 0 ? (
          searchResult?.map((item, index) => (
            <li key={index} onClick={() => suggestionSelected(item)}>
              {item.sname || item.name}
            </li>
          ))
        ) : (
          <li>No result found</li>
        )}
      </ul>

      <div styleName="search-icon">
        <MaginifyIcon />
      </div>
      {searchQuery?.length >= 0 && searchQuery?.toUpperCase() !== 'SENSEX' && (
        <div styleName="close-icon" onClick={() => clearSearch()}>
          <CloseIcon />
        </div>
      )}
    </div>
  );
};

SearchIndices.propTypes = {
  onStockSearch: PropTypes.func,
  onCloseSearch: PropTypes.func,
};

export default SearchIndices;
